export const arrayPlatesIT = [
        {
          name: 'Pasta al pomodoro',
          index: 'pasta-al-pomodoro',
          bgImage: require('./assets/piatto-bg-1.jpg'),
          thumbImage: require('./assets/130x130/pasta-al-pomodoro-thumb.png'),
          srcImage: require('./assets/680x680/pasta-al-pomodoro.png')
        },
        {
          name: 'Lasagna al forno',
          index: 'lasagna',
          bgImage: require('./assets/piatto-bg-2.jpg'),
          thumbImage: require('./assets/130x130/lasagna-thumb.png'),
          srcImage: require('./assets/680x680/lasagna.png')
        },
        {
          name: 'Frittata',
          index: 'frittata',
          bgImage: require('./assets/piatto-bg-1.jpg'),
          thumbImage: require('./assets/130x130/frittata-thumb.png'),
          srcImage: require('./assets/680x680/frittata.png')
        },
        {
          name:'Pasta e fagioli',
          index: 'pasta-e-fagioli',
          bgImage: require('./assets/piatto-bg-2.jpg'),
          thumbImage: require('./assets/130x130/pasta-e-fagioli-thumb.png'),
          srcImage: require('./assets/680x680/pasta-e-fagioli.png')
        },
        {
          name:'Risotto alla milanese',
          index: 'risotto-alla-milanese',
          bgImage: require('./assets/sfondi-piatti/sfondo-risotto-alla-milanese.png'),
          thumbImage: require('./assets/130x130/risotto-alla-milanese.png'),
          srcImage: require('./assets/680x680/risotto-alla-milanese.png')
        },
        {
          name:'Zuppa contadina',
          index: 'zuppa-contadina',
          bgImage: require('./assets/sfondi-piatti/sfondo-zuppa-contadina.png'),
          thumbImage: require('./assets/130x130/zuppa-contadina.png'),
          srcImage: require('./assets/680x680/zuppa-contadina.png')
        },
        {
          name:'Cous cous di verdure',
          index: 'cous-cous',
          bgImage: require('./assets/sfondi-piatti/sfondo-cous-cous.png'),
          thumbImage: require('./assets/130x130/cous-cous.png'),
          srcImage: require('./assets/680x680/cous-cous.png')
        },
        {
          name:'Tortellini alle erbe',
          index: 'tortellini-alle-erbe',
          bgImage: require('./assets/sfondi-piatti/sfondo-tortellini-alle-erbe.png'),
          thumbImage: require('./assets/130x130/tortellini-alle-erbe.png'),
          srcImage: require('./assets/680x680/tortellini-alle-erbe.png')
        },
        {
          name:"Spaghetti di soia con gamberi e verdure",
          index: 'spaghetti-soia',
          bgImage: require('./assets/sfondi-piatti/sfondo-spaghetti-soia.png'),
          thumbImage: require('./assets/130x130/spaghetti-soia.png'),
          srcImage: require('./assets/680x680/spaghetti-soia.png')
        },
        
        {
          name:'Pasta e broccoli',
          index: 'pasta-e-broccoli',
          bgImage: require('./assets/sfondi-piatti/sfondo-pasta-e-broccoli.png'),
          thumbImage: require('./assets/130x130/pasta-e-broccoli.png'),
          srcImage: require('./assets/680x680/pasta-e-broccoli.png')
        },
        {
          name:'Riso e piselli',
          index: 'riso-e-piselli',
          bgImage: require('./assets/sfondi-piatti/sfondo-riso-e-piselli.png'),
          thumbImage: require('./assets/130x130/riso-e-piselli.png'),
          srcImage: require('./assets/680x680/riso-e-piselli.png')
        },
        {
          name:"Sushi",
          index: 'sushi',
          bgImage: require('./assets/sfondi-piatti/sfondo-sushi.png'),
          thumbImage: require('./assets/130x130/sushi.png'),
          srcImage: require('./assets/680x680/sushi.png')
        },
        {
          name:'Hamburger',
          index: 'hamburger',
          bgImage: require('./assets/sfondi-piatti/sfondo-hamburger.png'),
          thumbImage: require('./assets/130x130/hamburger.png'),
          srcImage: require('./assets/680x680/hamburger.png')
        },
        {
          name:'Petto di pollo',
          index: 'petto-di-pollo',
          bgImage: require('./assets/sfondi-piatti/sfondo-petto-di-pollo.png'),
          thumbImage: require('./assets/130x130/petto-di-pollo.png'),
          srcImage: require('./assets/680x680/petto-di-pollo.png')
        },
        {
          name:'Merluzzo',
          index: 'merluzzo',
          bgImage: require('./assets/sfondi-piatti/sfondo-merluzzo.png'),
          thumbImage: require('./assets/130x130/merluzzo.png'),
          srcImage: require('./assets/680x680/merluzzo.png')
        },
        {
          name:'Tortino di verdure',
          index: 'tortini-di-verdure',
          bgImage: require('./assets/sfondi-piatti/sfondo-tortini-di-verdure.png'),
          thumbImage: require('./assets/130x130/tortini-di-verdure.png'),
          srcImage: require('./assets/680x680/tortini-di-verdure.png')
        },
        {
          name:"Fagioli all'uccelletto",
          index: 'fagioli-all-uccelletto',
          bgImage: require('./assets/sfondi-piatti/sfondo-fagioli-all-uccelletto.png'),
          thumbImage: require('./assets/130x130/fagioli-all-uccelletto.png'),
          srcImage: require('./assets/680x680/fagioli-all-uccelletto.png')
        },
        {
          name:"Hummus vegetale",
          index: 'hummus-vegetale',
          bgImage: require('./assets/sfondi-piatti/sfondo-hummus-vegetale.png'),
          thumbImage: require('./assets/130x130/hummus-vegetale.png'),
          srcImage: require('./assets/680x680/hummus-vegetale.png')
        },
        {
          name:"Mozzarella",
          index: 'mozzarella',
          bgImage: require('./assets/sfondi-piatti/sfondo-mozzarella.png'),
          thumbImage: require('./assets/130x130/mozzarella.png'),
          srcImage: require('./assets/680x680/mozzarella.png')
        },
        {
          name:"Prosciutto",
          index: 'prosciutto',
          bgImage: require('./assets/sfondi-piatti/sfondo-prosciutto.png'),
          thumbImage: require('./assets/130x130/prosciutto.png'),
          srcImage: require('./assets/680x680/prosciutto.png')
        },
        {
          name:"Polpette vegetali",
          index: 'polpette-vegetali',
          bgImage: require('./assets/sfondi-piatti/sfondo-polpette-vegetali.png'),
          thumbImage: require('./assets/130x130/polpette-vegetali.png'),
          srcImage: require('./assets/680x680/polpette-vegetali.png')
        },
        {
          name:"Insalata",
          index: 'insalata',
          bgImage: require('./assets/sfondi-piatti/sfondo-insalata.png'),
          thumbImage: require('./assets/130x130/insalata.png'),
          srcImage: require('./assets/680x680/insalata.png')
        },
        {
          name:"Patate al forno",
          index: 'patate-al-forno',
          bgImage: require('./assets/sfondi-piatti/sfondo-patate-al-forno.png'),
          thumbImage: require('./assets/130x130/patate-al-forno.png'),
          srcImage: require('./assets/680x680/patate-al-forno.png')
        },
        {
          name:"Zucchine",
          index: 'zucchine',
          bgImage: require('./assets/sfondi-piatti/sfondo-zucchine.png'),
          thumbImage: require('./assets/130x130/zucchine.png'),
          srcImage: require('./assets/680x680/zucchine.png')
        },
        {
          name:"Spinaci",
          index: 'spinaci',
          bgImage: require('./assets/sfondi-piatti/sfondo-spinaci.png'),
          thumbImage: require('./assets/130x130/spinaci.png'),
          srcImage: require('./assets/680x680/spinaci.png')
        },
        {
          name:"Ananas",
          index: 'ananas',
          bgImage: require('./assets/sfondi-piatti/sfondo-ananas.png'),
          thumbImage: require('./assets/130x130/ananas.png'),
          srcImage: require('./assets/680x680/ananas.png')
        },
        {
          name:"Arancia",
          index: 'arancia',
          bgImage: require('./assets/sfondi-piatti/sfondo-arancia.png'),
          thumbImage: require('./assets/130x130/arancia.png'),
          srcImage: require('./assets/680x680/arancia.png')
        },
        {
          name:"Mela",
          index: 'mela',
          bgImage: require('./assets/sfondi-piatti/sfondo-mela.png'),
          thumbImage: require('./assets/130x130/mela.png'),
          srcImage: require('./assets/680x680/mela.png')
        },
        {
          name:"Pera",
          index: 'pera',
          bgImage: require('./assets/sfondi-piatti/sfondo-pera.png'),
          thumbImage: require('./assets/130x130/pera.png'),
          srcImage: require('./assets/680x680/pera.png')
        }
      ]

 